import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { CollapsibleWidget, Paragraph } from 'components/patterns'

export const SwitchPartListHeader = styled(Paragraph)`
  font-size: 12px;
  color: ${themeColor('bluePrimary')};
`

export const Switch = styled.div`
  margin-bottom: 10px;
`

export const PartDescription = styled(Paragraph)`
  font-weight bold;
  font-size: 12px;
`

export const PartInfoList = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`

export const PartInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  margin-right: 5px;
  font-size: 12px;
  line-height: 1.33;
`

export const PartVehicleModel = styled(Paragraph)`
  font-size: 12px;
  margin-right: 4px;
`

export const PartNumber = styled(Paragraph)`
  font-size: 12px;
  margin-right: 5px;
`

export const CollapsibleSwitchList = styled(CollapsibleWidget)`
  margin-top: ${(props) => props.marginTop || '-10px'};
  margin-bottom: 0px;
  &&.ant-collapse > .ant-collapse-item {
    border-bottom: 0px;
  }
  &&.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding-left: 0 !important;
  }
  &&.ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    left: 155px;
  }
  &&.ant-collapse-borderless
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0px;
  }
`
